import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import ErrorMessage from '../../../ErrorMessage';
import NewProjectService from '../../../../Services/NewProjectService';

export default class NewProjectSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
    onlyActive: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    NewProjectService.GetProjectList(null, this.props.idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.displayName > b.displayName ? 1 : -1))
          .forEach((project, index) => {
            if (!this.props.onlyActive || this.isStartedProject(project)) {
              optValues.push({
                label: project.displayName,
                value: project.projectId,
                disabled: false,
              });
            }
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('NPS59');
      });
  }

  isStartedProject(project) {
    const today = new Date(dateTimeHelper.toYYYYsMMsDD(new Date()));
    const endDate = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(project.endDate), 30)));
    return new Date(project.startDate) < today && today < endDate;
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
